module.exports = __webpack_public_path__ + "img/fuel.9821b09b.svg";